import {Dayjs} from "dayjs";
import {InsightOverviewData} from "../types/domain/insightOverviewData";
import {handleAxiosError} from "./axiosErrorHandler";
import apiClient from "./baseService";

export const getInsightOverview = async (
    companyId: string,
    date: Dayjs,
    onlyActiveOrders: boolean,
    farmIds?: string[],
): Promise<InsightOverviewData> => {
    const url =
        farmIds && farmIds?.length > 0
            ? `/companies/${companyId}/overview/${date.format("YYYY-MM-DD")}/farm`
            : `/companies/${companyId}/overview/${date.format("YYYY-MM-DD")}`;
    const queryParams: Record<string, string | string[] | undefined> = {
        onlyActiveOrders: onlyActiveOrders.toString(),
        farmIds,
    };

    return await apiClient
        .get<InsightOverviewData>(url, {params: queryParams})
        .then((response) => response.data)
        .catch(handleAxiosError);
};
